import { monto } from "@/componentes/tesoreria/dinero"
import { Cabecera, Cuerpo, Fila, Tabla, Td, Th } from "@/componentes/ui/Tabla"

import { antiguedad, type Partida, TRAMOS } from "./indicadoresCartera"

/**
 * La antigüedad de saldos de la cartera (28/10): qué vence pronto y cuánto lleva vencido,
 * por tramo y por moneda. Sale de las mismas partidas que las tarjetas de arriba.
 *
 * ⚠ **Por moneda, sin convertir**: como las tarjetas. Pasarlo a dólares aquí daría una
 * cifra que no se puede comparar con ninguna de las de la pantalla.
 */
export function AntiguedadCartera({
  partidas,
  hoy,
  titulo,
}: {
  partidas: readonly Partida[]
  hoy: string
  titulo: string
}) {
  const tramos = antiguedad(partidas, hoy)
  const visibles = TRAMOS.filter((t) => tramos[t.clave].cuentas > 0)
  if (visibles.length === 0) return null
  return (
    <Tabla etiqueta={titulo}>
      <Cabecera>
        <Th>{titulo}</Th>
        <Th className="text-right">Cuentas</Th>
        <Th className="text-right">Saldo</Th>
      </Cabecera>
      <Cuerpo>
        {visibles.map((t) => {
          const b = tramos[t.clave]
          return (
            <Fila key={t.clave}>
              <Td style={t.vencido ? { color: "var(--destructive)" } : undefined}>{t.etiqueta}</Td>
              <Td className="text-right tabular-nums">{b.cuentas}</Td>
              <Td className="text-right tabular-nums">
                {b.montos.map((m) => `${monto(m.monto)} ${m.divisa}`).join(" · ")}
              </Td>
            </Fila>
          )
        })}
      </Cuerpo>
    </Tabla>
  )
}
